import { render, staticRenderFns } from "./ExportBatch.vue?vue&type=template&id=35d037ad"
import script from "./ExportBatch.vue?vue&type=script&lang=js"
export * from "./ExportBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports